import React from 'react';
import Tile from '../ui/Tile';
import TileHeader from '../ui/TileHeader';
import { FileEdit } from 'lucide-react';
import InvoiceDetails from './components/InvoiceDetails';
import InvoiceItems from './components/InvoiceItems';
import InvoiceActions from './components/InvoiceActions';

const InvoiceForm = ({
  title,
  items = [],
  formData = {},
  bankDetails = [],
  addItemDiv = () => {},
  removeItemDiv = () => {},
  handleInputChange = () => {},
  handleItemInputChange = () => {},
  handleInvoiceSubmit = (e) => e.preventDefault(),
  searchClients,
  suggestions = [],
  showSuggestions = false,
  clearSuggestions = () => {}
}) => {
  return (
    <div className="w-full">
      <Tile>
        <form onSubmit={handleInvoiceSubmit}>
          <TileHeader title={title || 'Данни за фактура'} icon={FileEdit} />
          <InvoiceDetails 
            formData={formData}
            handleInputChange={handleInputChange}
            bankDetails={bankDetails}
            searchClients={searchClients}
            suggestions={suggestions}
            showSuggestions={showSuggestions}
            clearSuggestions={clearSuggestions}
          />
          <InvoiceItems 
            items={items}
            handleItemInputChange={handleItemInputChange}
            addItemDiv={addItemDiv}
            removeItemDiv={removeItemDiv}
          />
          <InvoiceActions 
            handleInvoiceSubmit={handleInvoiceSubmit}
          />
        </form>
      </Tile>
    </div>
  );
};

export default InvoiceForm;
